var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 124,
    viewBox: "0 0 143 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7996 105.7C98.7996 105.7 121.5 83.0001 121.5 54.9001C121.5 26.8001 98.6996 4.1001 70.7996 4.1001C42.7996 4.1001 20.0996 26.8001 20.0996 54.9001C20.0996 83.0001 42.7996 105.7 70.7996 105.7Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.2 5.6C125.747 5.6 127 4.3464 127 2.8C127 1.2536 125.747 0 124.2 0C122.654 0 121.4 1.2536 121.4 2.8C121.4 4.3464 122.654 5.6 124.2 5.6Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 21.4999C24.3464 21.4999 25.6 20.2463 25.6 18.6999C25.6 17.1535 24.3464 15.8999 22.8 15.8999C21.2536 15.8999 20 17.1535 20 18.6999C20 20.2463 21.2536 21.4999 22.8 21.4999Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 75.5001C8.57188 75.5001 10.9 73.172 10.9 70.3001C10.9 67.4282 8.57188 65.1001 5.7 65.1001C2.82812 65.1001 0.5 67.4282 0.5 70.3001C0.5 73.172 2.82812 75.5001 5.7 75.5001Z",
    fill: "#E7EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.882 28.2974V87.302C118.882 89.0332 117.446 90.4759 115.723 90.4759H26.4888C24.7659 90.548 23.3301 89.1054 23.3301 87.3742V28.2974C23.3301 26.4941 24.7659 25.1235 26.4888 25.1235H115.723C117.518 25.1235 118.882 26.5662 118.882 28.2974Z",
    fill: "url(#paint0_linear)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.882 28.2974V32.8417H23.3301V28.2974C23.3301 26.4941 24.7659 25.1235 26.4888 25.1235H115.723C117.518 25.1235 118.882 26.5662 118.882 28.2974Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9326 55.7079C59.3996 55.7079 60.5888 54.513 60.5888 53.039C60.5888 51.565 59.3996 50.3701 57.9326 50.3701C56.4656 50.3701 55.2764 51.565 55.2764 53.039C55.2764 54.513 56.4656 55.7079 57.9326 55.7079Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3505 55.7079C85.8175 55.7079 87.0067 54.513 87.0067 53.039C87.0067 51.565 85.8175 50.3701 84.3505 50.3701C82.8836 50.3701 81.6943 51.565 81.6943 53.039C81.6943 54.513 82.8836 55.7079 84.3505 55.7079Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4495 73.2359H67.122C65.8298 73.2359 64.7529 72.1539 64.7529 70.8555C64.7529 69.5571 65.8298 68.4751 67.122 68.4751H75.3777C76.67 68.4751 77.7468 69.5571 77.7468 70.8555C77.8186 72.1539 76.7417 73.2359 75.4495 73.2359Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5661 30.3168C28.1608 30.3168 28.6429 29.8324 28.6429 29.2348C28.6429 28.6373 28.1608 28.1528 27.5661 28.1528C26.9714 28.1528 26.4893 28.6373 26.4893 29.2348C26.4893 29.8324 26.9714 30.3168 27.5661 30.3168Z",
    fill: "#F9FAFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9401 30.3168C31.5348 30.3168 32.017 29.8324 32.017 29.2348C32.017 28.6373 31.5348 28.1528 30.9401 28.1528C30.3454 28.1528 29.8633 28.6373 29.8633 29.2348C29.8633 29.8324 30.3454 30.3168 30.9401 30.3168Z",
    fill: "#F9FAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3854 30.3168C34.9802 30.3168 35.4623 29.8324 35.4623 29.2348C35.4623 28.6373 34.9802 28.1528 34.3854 28.1528C33.7907 28.1528 33.3086 28.6373 33.3086 29.2348C33.3086 29.8324 33.7907 30.3168 34.3854 30.3168Z",
    fill: "#F9FAFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.005 17.4773C114.287 17.4773 113.713 16.9003 113.713 16.1789V1.68023C113.713 0.958899 114.287 0.381836 115.005 0.381836C115.723 0.381836 116.297 0.958899 116.297 1.68023V16.1789C116.297 16.9003 115.723 17.4773 115.005 17.4773Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.486 28.586C125.486 27.8647 126.061 27.2876 126.779 27.2876H141.208C141.926 27.2876 142.5 27.8647 142.5 28.586C142.5 29.3073 141.926 29.8844 141.208 29.8844H126.779C126.061 29.8844 125.486 29.3073 125.486 28.586Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.338 19.2084C123.835 18.7035 123.835 17.8379 124.338 17.333L134.604 7.09012C135.106 6.58519 135.968 6.58519 136.47 7.09012C136.973 7.59505 136.973 8.46065 136.47 8.96558L126.276 19.2084C125.702 19.7134 124.84 19.7134 124.338 19.2084Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1.33008,
    y: 14.1235,
    width: 139.552,
    height: 109.355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 71.0747,
    y1: 23.6118,
    x2: 71.0747,
    y2: 91.1831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 115.091,
    y1: 25.1236,
    x2: 26.4074,
    y2: 28.9461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.5c3c86b5.svg";
export { ForwardRef as ReactComponent };